import { View } from '@react-pdf/renderer';

import { PropsWithChildren } from 'react';

import { tableStyles } from './tableStyles.js';

export function Table({ children }: PropsWithChildren) {
  return <View style={tableStyles.table}>{children}</View>;
}
